import { createAsyncThunk } from '@reduxjs/toolkit';
import TasksAPI from './tasksApi';

export const fetchTasksThunk = createAsyncThunk(
  'tasks/fetchTasks',
  async (params, { rejectWithValue }) => {
    try {
      return await TasksAPI.fetchTasks(params);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load tasks');
    }
  }
);

export const fetchTaskThunk = createAsyncThunk(
  'tasks/fetchTask',
  async (taskId, { rejectWithValue }) => {
    try {
      return await TasksAPI.fetchTask(taskId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load task');
    }
  }
);

export const createTaskThunk = createAsyncThunk(
  'tasks/createTask',
  async (taskData, { rejectWithValue }) => {
    try {
      return await TasksAPI.createTask(taskData);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to create task');
    }
  }
);

export const updateTaskThunk = createAsyncThunk(
  'tasks/updateTask',
  async ({ taskId, updates }, { rejectWithValue }) => {
    try {
      return await TasksAPI.updateTask(taskId, updates);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update task');
    }
  }
);

export const updateTaskStatusThunk = createAsyncThunk(
  'tasks/updateTaskStatus',
  async ({ taskId, status }, { rejectWithValue }) => {
    try {
      return await TasksAPI.updateTaskStatus(taskId, status);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update task status');
    }
  }
);

export const deleteTaskThunk = createAsyncThunk(
  'tasks/deleteTask',
  async (taskId, { rejectWithValue }) => {
    try {
      return await TasksAPI.deleteTask(taskId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to delete task');
    }
  }
);

export const fetchTaskCommentsThunk = createAsyncThunk(
  'tasks/fetchComments',
  async (taskId, { rejectWithValue }) => {
    try {
      const comments = await TasksAPI.fetchComments(taskId);
      return { taskId, comments };
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load comments');
    }
  }
);

export const addTaskCommentThunk = createAsyncThunk(
  'tasks/addComment',
  async ({ taskId, body }, { rejectWithValue }) => {
    try {
      const comment = await TasksAPI.addComment(taskId, body);
      return { taskId, comment };
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to add comment');
    }
  }
);
